/**
 * @description Custom event types for Branch.
 * PURCHASE and COMPLETE_REGISTRATION are Branch commerce and lifecycle specific events
 * https://help.branch.io/developers-hub/docs/tracking-commerce-content-lifecycle-and-custom-events
 */
export enum BranchEventType {
  NewOrder = 'PURCHASE',
  NewRegistration = 'COMPLETE_REGISTRATION',
  FirstMobileOrder = 'FirstMobileOrder',
  CompleteLoginCreation = 'COMPLETE_LOGIN_CREATION',
  AffiliateStarted = 'AFFILIATE_STARTED',
  Click = 'CLICK_FE',
  Install = 'INSTALL_FE'
}

export enum ReferralMethodType {
  AgentQRCodeExistingCustomer = 1,
	ReferralLinkExistingCustomer = 2,
  AgentQRCodeNewCustomer = 3,
  ReferralLinkNewCustomer = 4
}

export enum deepLinkReferralMethodVerify {
  RequiresNewCustomerCreation = 225,
  ConfirmCustomer = 230
}


// WEBPACK FOOTER //
// ./src/model/types/branch-event-type.ts